import React, { useState, useEffect, useRef } from 'react';
import { RemoveRedEye } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

interface IPatientViewerData {
  userCount: number;
  hasMultipleUsers: boolean;
  socketCount: number;
  userIds: number[];
  socketIds: string[];
}

export const MultiuserIndicator = () => {
  const [viewerData, setViewerData] = useState<IPatientViewerData>({
    userCount: 1,
    hasMultipleUsers: false,
    socketCount: 1,
    userIds: [],
    socketIds: [],
  });

  const [userConnections, setUserConnections] = useState<Record<string, any>>({});
  const lastState = useRef({});

  useEffect(() => {
    const processMessage = (event: MessageEvent) => {
      if (event.data.source === 'patientViewerCounts') {
        setViewerData(event.data.data);
        return;
      }

      if (event.data.source === 'multiuserConnections') {
        lastState.current = event.data.conns;
        setUserConnections(event.data.conns);
      }
    };

    window.addEventListener('message', processMessage);
    return () => window.removeEventListener('message', processMessage);
  }, []);

  const hasMultipleUsers = Object.keys(userConnections).length > 0;
  const otherUserNames = Object.values(userConnections);
  const iconColor = hasMultipleUsers ? '#c78a80' : '#70777a44';

  const iconElement = (
    <div style={{ position: 'relative', width: '26px', height: '20px' }}>
      <RemoveRedEye
        style={{
          fill: iconColor,
          fontSize: '20px',
          marginRight: 6,
          transform: 'translateY(-1px)',
        }}
      />
    </div>
  );

  if (!hasMultipleUsers || otherUserNames.length === 0) {
    return iconElement;
  }

  return (
    <Tooltip
      title={otherUserNames.map(userName => (
        <div key={`userConnection-${userName}`}>{userName}</div>
      ))}
    >
      {iconElement}
    </Tooltip>
  );
};
